import { Component, Input } from '@angular/core';
import { ApiPollActivity } from '@tytapp/api';

@Component({
    selector: 'tyt-petition-recent-signers',
    templateUrl: './petition-recent-signers.component.html',
    styleUrls: ['./petition-recent-signers.component.scss']
})
export class PetitionRecentSignersComponent {

    @Input()
    signers: ApiPollActivity[];

    constructor() {
    }

}
